import { render } from "./Explainer.vue?vue&type=template&id=56d8a401&scoped=true"
import script from "./Explainer.vue?vue&type=script&lang=js"
export * from "./Explainer.vue?vue&type=script&lang=js"

import "./Explainer.vue?vue&type=style&index=0&id=56d8a401&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d8a401"]])

export default __exports__